import './sectionCTA.css';

function SectionsCTA({Titulo,cor,srcImg}) {
    return (
      <div className="SectionsCTA">
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
                <h1 className='tituloCTA'>{Titulo}</h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default SectionsCTA;